import gql from 'graphql-tag';
import { graphql } from 'react-apollo';
import { DeferredJob } from './jobInvoiceableDeferredInbox';

export const TicketsOnJobGQL = gql`
  query TicketsOnJobQuery($jobId: Int!) {
    job(job_id: $jobId) {
      ...DeferredJob
      tickets {
        edges {
          node {
            id
            date {
              month
              day
            }
          }
        }
      }
    }
  }
  ${DeferredJob}
`;

/* NOTE: Returned a cache copy of the data, never requeried */
export default graphql(TicketsOnJobGQL, { options: { fetchPolicy: 'network-only' } });
